import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { NgxImageCompressService } from 'ngx-image-compress';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import { ELearningManagementService } from '../e-learning-management.service';

const getBase64 = (file: File): Promise<string | ArrayBuffer | null> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

@Component({
  selector: 'app-private-chat-management',
  templateUrl: './private-chat-management.component.html',
  styleUrls: ['./private-chat-management.component.scss']
})
export class PrivateChatManagementComponent implements OnInit {
  @ViewChild('chatroom') private chatroom: ElementRef;

  course: any;
  courseId: string;
  courseName: string;
  isLoading: boolean = false;

  chatUser = [];

  privateMessage = [];
  privateChatImg = [];
  privateChatRemoveFile = [];
  privateChatForm: FormGroup
  username: string;
  user_id: string;

  fileList: NzUploadFile[] = [];
  previewImage: string | undefined = '';
  previewVisible = false;

  //  for compress image
  localUrl: any;
  localCompressedURl: any;
  imgResultBeforeCompress: string;
  imgResultAfterCompress: string;

  successRequest = ({ file, onSuccess, onError }) => {
    const fileType = this.gobalFunctionService.getTypeFile(file);

    if (fileType === 'pdf' || fileType === 'doc' || fileType === 'docx' || fileType === 'xlsx' || fileType === 'csv' || fileType === 'jpg' || fileType === 'png' || fileType === 'jpeg') {
      setTimeout(() => {
        onSuccess("ok");
      }, 0);
    } else {
      setTimeout(() => {
        onError('error');
      }, 0);
    }
  };

  constructor(
    private eLearningManagementService: ELearningManagementService,
    private gobalFunctionService: GobalFunctionService,
    private gbFunction: GobalFunctionService,
    private fb: FormBuilder,
    private imageCompress: NgxImageCompressService,
    private router: Router,
  ) {
    this.privateChatForm = this.fb.group({
      message: ['', Validators.required],
      messageType: ['text', Validators.required],
      userType: ['admin', Validators.required],
      imageName: [''],
      file: ['']
    })
  }

  ngOnInit(): void {
    this.gobalFunctionService.setTitle('ข้อความส่วนตัว');

    this.courseId = new URL(location.href).searchParams.get('course_id');

    this.eLearningManagementService.getAllPrivateChat(this.courseId).pipe(
      map(res => {
        if (res.success) {
          // console.log(res);
          this.course = res.result;
          res.result.map(c => {
            this.chatUser.push(
              {
                ID: c.ID,
                USER_ID: c.USER_ID,
                USERNAME: c.USERNAME,
                LAST_MESSAGE: c.LAST_MESSAGE,
                CHAT_ID: c.CHAT_ID,
                COUNT_UNREAD: c.COUNT_UNREAD,
                ACTIVE: false,
              },
            )
          })
          // console.log(this.chatUser);
        }
      }),
      catchError((err) => {
        alert(err.error.message);
        this.router.navigate(['/']);
        return of(false)
      })
    ).subscribe();

  }

  selectUser(u) {
    // console.log(u);

    this.username = u.USERNAME;
    this.user_id = u.USER_ID;
    u.ACTIVE = !u.ACTIVE;
    u.COUNT_UNREAD = 0;
    for (let but of this.chatUser) {
      but.ACTIVE = false;
    }
    u.ACTIVE = true;

    this.getPrivateChat(this.courseId, u.USER_ID);
  }

  getPrivateChat(cid, uid) {

    this.eLearningManagementService.getPrivateChatByUser(cid, uid).pipe(
      map(res => {
        this.privateMessage = res.result;

        setTimeout(() => {
          this.scrollToBottom();
        }, 1000);
      })
    ).subscribe();
  }

  sendTextStatus: boolean;
  sendImageStatus: boolean;

  getStatusSending(e) {
    if (e.trim() === '') {
      this.sendTextStatus = false;
    } else {
      this.sendTextStatus = true;
    }

  }

  handleChange(e, chatForm) {
    // console.log(e);
    let fileName: any;
    let fileList = [...e.fileList];
    const fileType = this.gbFunction.getTypeFile(e.file);
    fileName = e.file.originFileObj.name;
    let newObj


    switch (e.file.status) {
      case 'done': {

        if (fileType === 'jpg' || fileType === 'png' || fileType === 'jpeg') {
          var reader = new FileReader();
          reader.onload = (event: any) => {
            // // console.log(event);

            // image before compress
            this.imgResultBeforeCompress = reader.result as string;
            this.localUrl = event.target.result;
            // newFile = this.compressFile(this.localUrl, fileName, fileType);
            this.compressFile(this.localUrl, fileName, fileType).then(data => {
              // console.log(data);
              // // console.log(data.name);
              newObj = data;
              newObj['uid'] = e.file.originFileObj.uid

              // console.log(newObj);
              // // console.log(e.fileList.indexOf(data.name));
              var index = e.fileList.findIndex(
                (file) => file.name === newObj.name
              )
              // console.log(index);
              if (index !== -1) {
                e.fileList[index].originFileObj = newObj;
                e.fileList[index].lastModified = newObj.lastModified;
                e.fileList[index].lastModifiedDate = newObj.lastModifiedDate;
                e.fileList[index].size = newObj.size;
              }

              if (fileList.length > 5) {
                let removeExcess = [...fileList].splice(0, fileList.length - 5);

                e.fileList = fileList.slice(-5);

                for (let i = 0; i < removeExcess.length; i++) {
                  if (removeExcess[i].uid) {
                    this.privateChatRemoveFile.push(removeExcess[i].uid)
                  }
                }
              }

              fileList = fileList.slice(-5);
              fileList = fileList.map(file => {
                if (file.response) {
                  file.url = file.response.url;
                }
                return file;
              });

              chatForm.patchValue({
                file: e
              });
              chatForm.get('file').updateValueAndValidity();

              this.fileList = fileList;
              // console.log(this.privateChatForm);
            })

          }
          reader.readAsDataURL(e.file.originFileObj);

        } else if (fileType === 'pdf' || fileType === 'doc' || fileType === 'docx' || fileType === 'xlsx' || fileType === 'csv') {
          if (fileList.length > 5) {
            let removeExcess = [...fileList].splice(0, fileList.length - 5);

            e.fileList = fileList.slice(-5);

            for (let i = 0; i < removeExcess.length; i++) {
              if (removeExcess[i].uid) {
                this.privateChatRemoveFile.push(removeExcess[i].uid)
              }
            }
          }

          fileList = fileList.slice(-5);
          fileList = fileList.map(file => {
            if (file.response) {
              file.url = file.response.url;
            }
            return file;
          });

          chatForm.patchValue({
            file: e
          });
          chatForm.get('file').updateValueAndValidity();

          this.fileList = fileList;
        }
        this.sendImageStatus = true;
        break;
      }
      case 'removed': {
        // console.log(e);
        if (typeof (e.file.uid) === 'number') {
          this.privateChatRemoveFile.push(e.file.uid)
        } else {
          chatForm.patchValue({
            file: e
          });
          chatForm.get('file').updateValueAndValidity();
        }
        break;
      }
    }

    if (e.fileList.length === 0) {
      this.sendImageStatus = false;
    }

    // console.log(this.privateChatForm);

  }

  compressFile(image, fileName, fileType) {
    // // console.log(image);
    var type = fileType === 'jpg' ? 'image/jpeg' : fileType === ' jpeg' ? 'image/jpeg' : 'image/png';
    var orientation = -1;
    return this.imageCompress.compressFile(image, orientation, 50, 50).then(
      result => {
        this.imgResultAfterCompress = result;
        this.localCompressedURl = result;
        // create file from byte
        const imageName = fileName;
        // call method that creates a blob from dataUri
        const imageBlob = this.dataURItoBlob(this.imgResultAfterCompress.split(',')[1]);
        const imageFile = new File([imageBlob], imageName, { type: type });

        return imageFile
      }
    );
  }

  dataURItoBlob(dataURI) {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: 'image/jpeg' });
    return blob;
  }

  handlePreview = async (file: NzUploadFile): Promise<void> => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj!);
    }
    this.previewImage = file.url || file.preview;
    this.previewVisible = true;
  }

  sendPrivateChat(form) {
    // console.log(form);
    let fileType
    this.isLoading = true;

    if (form.value.message.trim() === '') {
      // console.log(form);
      form.controls['message'].setValue('');
      form.controls['messageType'].setValue('text');
      form.controls['userType'].setValue('user');
      form.controls['imageName'].setValue('');

    } else {

      this.privateChatImg.push(
        {
          MESSAGE_TYPE: form.value.messageType,
          USER_TYPE: form.value.userType,
          MESSAGE: form.value.message,
          IMAGE_NAME: form.value.imageName
        }
      )
    }

    if (form.value.file !== '') {
      form.value.file.fileList.forEach(e => {
        // console.log(e.name);
        switch (e.type) {
          case 'application/pdf':
          case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
          case 'application/vnd.ms-excelapplication/msword':
          case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
          case 'text/csv':
          case 'application/vnd.ms-excel': {
            fileType = 'file';
          } break;

          case 'image/jpeg':
          case 'image/png': {
            fileType = 'image';
          }
        }
        this.privateChatImg.push(
          {
            MESSAGE_TYPE: fileType,
            USER_TYPE: "admin",
            MESSAGE: "",
            IMAGE_NAME: e.name
          }
        )
      });
    }

    this.eLearningManagementService.postPrivateChatTA(form.value, this.privateChatImg, this.courseId, this.user_id).pipe(
      switchMap(res => {
        if (res.success) {
          return this.eLearningManagementService.getPrivateChatByUser(this.courseId, this.user_id).pipe(
            map(c => {
              if (res.success) {

                form.controls['message'].setValue('');
                form.controls['messageType'].setValue('text');
                form.controls['userType'].setValue('admin');
                form.controls['imageName'].setValue('');
                form.controls['file'].setValue('');
                this.fileList = [];
                this.privateChatImg = [];

                this.privateMessage = c.result;
                this.sendImageStatus = false;
                this.sendTextStatus = false;

                setTimeout(() => {
                  this.scrollToBottom();
                  this.isLoading = false;
                }, 1000);
              }
            })
          )
        }

      }),
      catchError(err => {
        alert(err.error.message);
        return of(false);
      })
    ).subscribe();
    // // console.log(this.privateChatImg);
    // // console.log(this.privateMessage);
  }


  downloadFile(fileUrl) {
    window.open(fileUrl, "_blank");
  }

  scrollToBottom(): void {
    try {
      this.chatroom.nativeElement.scrollTop = this.chatroom.nativeElement.scrollHeight;
    } catch (err) { }
  }

}
